document.getElementById('counter-button').addEventListener('click', async () => {
  const newCount = await incrementPrestiCount();
  document.getElementById('counter-button').textContent = newCount;
  console.log(getPrestiCount());
});

async function getPrestiCount() {
  const url = `https://isotope.howardmiller.com/presti/howardmiller/count`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log(data);
  } catch (error) {
    console.error(error);
  }
}

async function incrementPrestiCount() {
  const url = `https://isotope.howardmiller.com/presti/howardmiller/increment`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }
    
    const data = await response.json();
    console.log(data);
    return data.presti_counter; 
  } catch (error) {
    console.error("Failed to increment counter:", error);
    return "Error"; 
  }
}
